import PlayerTextResponse from './player-text-response';

export default PlayerTextResponse;
